<template>
    <div class="modern-card">
        <div class="card-header">
            <h2 class="card-title text-center mb-0">Jetzt abstimmen</h2>
        </div>

        <div class="card-content">
            <p class="text-center mb-4">
                Teile uns mit, wie du die Lage bei Hertha aktuell siehst. Um so besser deine Stimmung, um so höher die Punktzahl.
            </p>

            <div class="slider-container mb-4">
                <vue-slider v-model="sliderValue" :min="1" :max="10" :dotSize="28" :interval="1" :marks="true" :tooltip="'none'"
                    class="text-center" :contained="true" />
            </div>

            <div class="text-center mb-4">
                <h4 class="mb-0">Auswahl: {{ sliderValue }}</h4>
                <div class="bg-dark rounded m-2 p-2">
                    <i :class="selectedAdjective.color" class="fw-bold">{{ selectedAdjective.text }}</i>
                    <span class="ms-2 fs-4">{{ selectedAdjective.emoji }}</span>
                </div>
            </div>

            <template v-if="!hasVoted">
                <div class="text-center">
                    <button @click="submitRating" :disabled="isRequesting" class="modern-btn">
                        Abstimmen
                        <span v-if="isRequesting" class="spinner-border spinner-border-sm ms-2" role="status" aria-hidden="true"></span>
                    </button>
                </div>
                <template v-if="votedFor && votedFor > 0">
                    <div class="text-center mt-3">
                        <small class="">Deine letzte Abstimmung: <strong>{{ votedFor }}</strong></small>
                    </div>
                </template>
            </template>

            <div v-else id="feedback" class="success-dialog rounded p-3 mt-3">
                <div class="text-center">
                    <strong class="">Deine Stimme wurde gezählt 🥳</strong>
                    <p class="mb-0 mt-2">
                        Du kannst jederzeit neu abstimmen. Bei mehrfacher Abstimmung innerhalb von 14 Tagen zählt nur deine letzte Stimme.
                    </p>
                </div>
            </div>

            <!-- Emoji Rain Animation Container -->
            <div v-if="showEmojiRain" class="emoji-rain-container">
                <div v-for="n in 15" :key="n" class="emoji-rain">{{ selectedAdjective.emoji }}</div>
            </div>

            
        </div>
    </div>
</template>

<script>
import { reactive, toRefs, computed, ref } from 'vue';
import VueSlider from 'vue-slider-component';
import 'vue-slider-component/theme/default.css';
import axios from 'axios';
import { toast } from 'vue3-toastify';
import emitter from '../event-emitter';
import * as utils from '../utils.js';
import { ratingOptions } from '../ratingData';



export default {
    components: {
        VueSlider
    },
    mounted() {},
    setup() {
        let isRequesting = ref(false);
        let hasVoted = ref(false);
        let votedFor = ref(0);
        let itsMd = ref(false);
        let showEmojiRain = ref(false);
        votedFor.value = localStorage.getItem('voted-for');

        const sliderData = reactive({
            sliderValue: (votedFor.value && votedFor.value > 0 ? parseInt(votedFor.value) : 5),
            dotSize: 14
        });

        const errorMsg = 'Es ist ein Fehler aufgetreten. Bitte versuche es erneut. Falls der Fehler bestehen bleibt, kontaktiere bitte @flixius auf dem Herthabase Discord-Server, oder schreibe eine E-Mail an kontakt@herthabase.de';
        const userIdisNull = 'Fehler: Deine UserId ist NULL. Bitte die Seite neu laden, nochmal probieren und idealerweise @Flixius auf Discord Bescheid geben, dass dieser Fehler immer noch existiert. :-(';
        //const succMsg = '🥳 Deine Stimme wurde erfolgreich abgegeben. 💙';

        const selectedAdjective = computed(() => {
            return ratingOptions[sliderData.sliderValue - 1];
        });

        const submitRequest = async (token) => {
            try {
                var userId = localStorage.getItem('user-id');
                if (!userId) {
                    toast.error(userIdisNull);
                    return;
                }

                const response = await axios.post(process.env.VUE_APP_BACKEND_URL + '/stimmungsbarometer/submitRating', { rating: sliderData.sliderValue, uId: userId, gToken: token });
                //response received successfully
                if (response.status === 200) {
                    //toast.success(succMsg);
                    hasVoted.value = true;
                    localStorage.setItem('voted-for', sliderData.sliderValue);
                    votedFor = sliderData.sliderValue;
                    utils.setHasVoted();

                    // Trigger emoji rain animation
                    showEmojiRain.value = true;
                    setTimeout(() => {
                        showEmojiRain.value = false;
                    }, 6500); // Hide after animation completes (6s animation + 0.5s buffer)

                    emitter.emit("ShowResultNow", true);
                } else
                    toast.error(errorMsg);
            }
            catch (error) {
                toast.error(errorMsg);
            }
            finally {
                isRequesting.value = false;
            }
        };
        const submitRating = async () => {
            isRequesting.value = true;

            if (process.env.VUE_APP_ENVIRONMENT == 'DEBUG') {
                await submitRequest(null);
                return;
            }

            window.grecaptcha.ready(async function () {
                const token = await window.grecaptcha.execute(process.env.VUE_APP_RECAPTCHA_SITEKEY, { action: 'submit' });     //i receive a token successfully
                await submitRequest(token);
            });
        };


        emitter.on("OnVotingSummaryRequested", _ => {
            itsMd.value = _.itsMatchday;
        });

        return {
            ...toRefs(sliderData),
            selectedAdjective,
            submitRating,
            isRequesting,
            hasVoted,
            votedFor,
            itsMd,
            showEmojiRain
        };
    }
}
</script>
